/* Prime Honey cart drawer.
   Ported from Prime Organics' po-cart-drawer: same shell, rows, gift lines, footer
   and wallet relocation. The subscription half of that drawer is deliberately NOT
   here - this store has zero selling plans, so there is nothing to convert a line to
   and a "Save with Subscription" button could only mislead or mischarge.

   This store had no drawer at all before: the cart icon was a plain link to /cart,
   which is why opening the cart showed the page footer underneath it. This
   intercepts those links and opens a real drawer instead. */
(function () {
  var d = document, cfg = {}, drawerEl = null, bgEl = null, accHolder = null, lastFocus = null;

  try { cfg = JSON.parse((d.getElementById('phcd-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var S = function (k, dflt) { var v = cfg[k]; return (v === undefined || v === null || v === '') ? (dflt || '') : v; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var moneyFmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(cents) {
    var n = (cents || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: moneyFmt }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }

  /* A line is a gift when it costs nothing. Kaching adds its free-gift lines at
     $0.00, so this needs no property flag and keeps working if the deal is rebuilt. */
  function isGift(it) { return (it.final_line_price === 0) || (it.final_price === 0); }

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5.5c0 4.3-2.9 8.1-7 9.5-4.1-1.4-7-5.2-7-9.5V6l7-3z"/><path d="M9.2 12.2l2 2 3.6-4"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/><path d="M12 7C12 7 10.5 3 8 3a2.5 2.5 0 0 0 0 5h4zM12 7c0 0 1.5-4 4-4a2.5 2.5 0 0 1 0 5h-4z"/></svg>'
  };

  function build() {
    if (drawerEl) return;
    d.documentElement.setAttribute('data-phcd-on', '');

    bgEl = d.createElement('div'); bgEl.className = 'phcd__bg';
    drawerEl = d.createElement('div');
    drawerEl.className = 'phcd';
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-modal', 'true');
    drawerEl.setAttribute('aria-label', S('title', 'Your cart'));
    drawerEl.setAttribute('tabindex', '-1');
    drawerEl.innerHTML =
      '<div class="phcd__head">' +
        '<span class="phcd__title">' + esc(S('title', 'Your cart')) + '</span>' +
        '<span class="phcd__count" data-count>0</span>' +
        '<button type="button" class="phcd__x" aria-label="' + esc(S('close_label', 'Close cart')) + '" data-close>' + ICON.x + '</button>' +
      '</div>' +
      '<div class="phcd__strip" data-strip hidden></div>' +
      '<div class="phcd__body" data-body></div>' +
      '<div data-fbt></div>' +
      '<div class="phcd__foot" data-foot></div>' +
      '<div class="phcd__spin" aria-hidden="true"></div>';
    d.body.appendChild(bgEl);
    d.body.appendChild(drawerEl);

    bgEl.addEventListener('click', function () { close(); });
    drawerEl.addEventListener('click', onClick);
    d.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && drawerEl.classList.contains('open')) close();
      if ((e.key === 'Tab' || e.keyCode === 9) && drawerEl.classList.contains('open')) trap(e);
    });
  }

  function trap(e) {
    var f = drawerEl.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- rows ---------- */
  function rowHTML(it) {
    var gift = isGift(it);
    var img = it.image ? '<img class="phcd__ci-img" src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">'
                       : '<div class="phcd__ci-img"></div>';
    var sub = (it.variant_title && it.variant_title !== 'Default Title') ? esc(it.variant_title) : '';
    var price = gift
      ? '<span class="phcd__ci-price is-free">FREE</span>'
      : '<span class="phcd__ci-price">' + money(it.final_line_price) + '</span>' +
        (it.original_line_price > it.final_line_price ? '<s class="phcd__ci-was">' + money(it.original_line_price) + '</s>' : '');

    var side = gift
      ? '<span class="phcd__ci-gifttag">' + ICON.gift + 'FREE</span>'
      : '<div class="phcd__qty">' +
          '<button type="button" data-dec="' + esc(it.key) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-inc="' + esc(it.key) + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="phcd__ci-del" data-del="' + esc(it.key) + '">Remove</button>';

    return '<div class="phcd__ci' + (gift ? ' is-gift' : '') + '">' + img +
      '<div class="phcd__ci-main">' +
        '<p class="phcd__ci-name">' + esc(it.product_title) + '</p>' +
        (sub ? '<p class="phcd__ci-sub">' + sub + '</p>' : '') +
        (gift && S('gift_line') ? '<p class="phcd__ci-sub">' + esc(S('gift_line')) + '</p>' : '') +
        '<div class="phcd__ci-pricerow">' + price + '</div>' +
      '</div>' +
      '<div class="phcd__ci-side">' + side + '</div>' +
    '</div>';
  }

  function fbtHTML(cart) {
    var list = (cfg.fbt || []).filter(Boolean).filter(function (p) {
      if (!p.available) return false;
      return !cart.items.some(function (it) { return String(it.variant_id) === String(p.variant_id); });
    });
    if (!list.length) return '';
    return '<div class="phcd__fbt"><p class="phcd__fbt-title">' + esc(S('fbt_title', 'Frequently bought together:')) + '</p>' +
      '<div class="phcd__fbt-rail">' + list.map(function (p) {
        return '<div class="phcd__fbt-card">' +
          (p.image ? '<img class="phcd__fbt-img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<div class="phcd__fbt-img"></div>') +
          '<div class="phcd__fbt-main">' +
            '<p class="phcd__fbt-name">' + esc(p.title) + '</p>' +
            (p.sub ? '<p class="phcd__fbt-sub">' + esc(p.sub) + '</p>' : '') +
            '<p class="phcd__fbt-price">' + money(p.price) + '</p>' +
          '</div>' +
          '<button type="button" class="phcd__fbt-add" data-add="' + esc(p.variant_id) + '">Add</button>' +
        '</div>';
      }).join('') + '</div></div>';
  }

  function perksHTML() {
    var perks = (cfg.perks || []).filter(Boolean);
    if (!perks.length) return '';
    return '<div class="phcd__perks">' + perks.map(function (p) {
      var bits = String(p).split('|');
      return '<div class="phcd__perk">' + ICON.check + '<span><b>' + esc(bits[0]) + '</b> ' + esc(bits[1] || '') + '</span></div>';
    }).join('') + '</div>';
  }

  function trustHTML() {
    if (!S('trust_text')) return '';
    var r = parseFloat(S('trust_rating', '0')) || 0;
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += '<span' + (i <= Math.round(r) ? ' class="on"' : '') + '>' + ICON.check + '</span>';
    return '<div class="phcd__trust">' + (S('trust_label') ? '<b>' + esc(S('trust_label')) + '</b>' : '') +
      '<span class="phcd__stars">' + stars + '</span><span>' + esc(S('trust_text')) + '</span></div>';
  }

  function footHTML(cart) {
    if (!cart.items.length) return '';
    var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
    return '<div class="phcd__totrow">' +
        '<span class="phcd__totlbl">' + esc(S('total_label', 'Subtotal')) + '</span>' +
        '<span class="phcd__totright">' +
          (saved > 0 ? '<span class="phcd__off">You save ' + money(saved) + '</span>' : '') +
          (saved > 0 ? '<s class="phcd__was">' + money(cart.original_total_price) + '</s>' : '') +
          '<span class="phcd__tot">' + money(cart.total_price) + '</span>' +
        '</span>' +
      '</div>' +
      (S('tag_text') ? '<div class="phcd__tagwrap"><span class="phcd__tag">' + esc(S('tag_text')) + '</span></div>' : '') +
      '<a class="phcd__primary" href="/checkout"><span class="lbl">' + esc(S('primary', 'Checkout')) + '</span>' +
        '<span class="prc">' + money(cart.total_price) + '</span>' + ICON.arrow + '</a>' +
      (S('guarantee') ? '<div class="phcd__guarantee"><span>' + ICON.shield + esc(S('guarantee')) + '</span></div>' : '') +
      perksHTML() +
      '<div class="phcd__accwrap"></div>' +
      trustHTML();
  }

  /* ---------- render ---------- */
  function renderCart(cart) {
    var paid = cart.items.filter(function (it) { return !isGift(it); });
    var count = paid.reduce(function (n, it) { return n + it.quantity; }, 0);
    drawerEl.querySelector('[data-count]').textContent = count;

    var strip = drawerEl.querySelector('[data-strip]');
    if (S('strip') && cart.items.length) { strip.innerHTML = S('strip'); strip.hidden = false; }
    else strip.hidden = true;

    /* gifts last, so the thing they paid for reads first */
    var ordered = paid.concat(cart.items.filter(isGift));
    drawerEl.querySelector('[data-body]').innerHTML = cart.items.length
      ? ordered.map(rowHTML).join('')
      : '<div class="phcd__empty">' + esc(S('empty_text', 'Your cart is empty')) + '</div>';
    drawerEl.querySelector('[data-fbt]').innerHTML = cart.items.length ? fbtHTML(cart) : '';
    drawerEl.querySelector('[data-foot]').innerHTML = footHTML(cart);
    moveWallets();
    syncBubble(count);
  }

  /* Shopify only renders the wallet buttons once per page, so they are rendered
     off-screen by the section and MOVED in here rather than duplicated.

     Move the WHOLE off-screen node's children, form included, and then delete the
     husk. Moving only the inner .phcd__acc div leaves `{% form 'cart' %}` behind:
     the accelerated-checkout component is then detached from the form it posts
     with, and a stray <form action="/cart"> is left on the page that any stray
     submit inside it resolves to the /cart PAGE. That is the bug that made the
     cart page appear under the drawer, footer and all. */
  function moveWallets() {
    var wrap = drawerEl.querySelector('.phcd__accwrap');
    if (!wrap) return;
    if (!accHolder) {
      var src = d.getElementById('phcd-acc-src');
      if (!src) return;
      accHolder = d.createElement('div');
      accHolder.className = 'phcd__acchold';
      while (src.firstChild) accHolder.appendChild(src.firstChild);
      if (src.parentNode) src.parentNode.removeChild(src);
    }
    if (accHolder.parentNode !== wrap) {
      wrap.appendChild(accHolder);
      /* the component has to be re-initialised after being reparented */
      try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch (e) {}
    }
  }

  function syncBubble(n) {
    d.querySelectorAll('[data-ph-cart-count]').forEach(function (el) { el.textContent = n; });
  }


  /* ---- tier-gated digital gift ------------------------------------------------
     Adds a $0 line when the cart is on one of the allowed Kaching deal bars, and
     removes it when the shopper drops back to a bar that does not include it.

     OFF unless BOTH ebook_variant_id and ebook_deal_ids are set on the section, so
     every template that does not set them behaves exactly as before. The reconcile
     runs inside refresh() and re-enters at most once, guarded by `reconciling`,
     because add/remove both trigger another cart read. */
  var reconciling = false;

  /* Read one cart line's offer-app payload, or null. */
  function kbOf(it) {
    var kb = (it.properties || {}).__kaching_bundles;
    if (!kb) return null;
    if (typeof kb === 'string') { try { kb = JSON.parse(kb); } catch (e) { return null; } }
    return kb || null;
  }

  /* Every offer id the cart is currently carrying. The app writes TWO: `deal` is one id
     for the whole offer and is identical on all three bars, while `bid` identifies the
     selected bar. The gate settings hold bar ids, so matching only `deal` meant a
     bar-scoped gate could never open. Both are returned and either may match. */
  function dealIdsIn(cart) {
    var out = [];
    for (var i = 0; i < (cart.items || []).length; i++) {
      var kb = kbOf(cart.items[i]);
      if (!kb) continue;
      if (kb.deal && out.indexOf(String(kb.deal)) === -1) out.push(String(kb.deal));
      if (kb.bid && out.indexOf(String(kb.bid)) === -1) out.push(String(kb.bid));
    }
    return out;
  }

  function giftLine(cart, vid) {
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) return cart.items[i];
    }
    return null;
  }

  /* Quantity of one variant across the cart, ignoring lines the offer already zeroed. */
  function qtyOf(cart, vid) {
    var n = 0;
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (String(cart.items[i].variant_id) === String(vid)) n += cart.items[i].quantity || 0;
    }
    return n;
  }

  /* Variant ids present in the cart, from a comma separated setting. */
  function idList(name) {
    var raw = S(name);
    if (!raw) return [];
    return raw.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  /* Resolve one gate to a boolean. Deal mode reads the offer app's selected bar for
     products that have an app deal, quantity mode counts a trigger variant for products
     that do not. Deal mode wins when both are set. */
  function gateOpen(cart, dealIds, trigger, minQty) {
    if (dealIds) {
      var list = dealIds.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var have = dealIdsIn(cart);
      for (var i = 0; i < have.length; i++) if (list.indexOf(have[i]) !== -1) return true;
      return false;
    }
    if (trigger && minQty > 0) return qtyOf(cart, trigger) >= minQty;
    return null;                                  /* not configured */
  }

  function reconcileGift(cart, done) {
    if (reconciling) { done(cart); return; }

    /* Two independent gates, because the two kinds of gift unlock at different points.
       On Overdrive the digital guide starts at the second deal bar while the physical
       stack rides every bar; on Shilajit the guide starts at 4 jars and the stack at 2.
       Each gate contributes its own variants to one add and one remove request. */
    var want = {}, known = {};

    var single = S('ebook_variant_id');
    if (single) {
      var g1 = gateOpen(cart, S('ebook_deal_ids'), S('ebook_trigger_variant'),
                        parseInt(S('ebook_min_qty') || '0', 10));
      if (g1 !== null) { known[single] = 1; if (g1) want[single] = 1; }
    }

    var stack = idList('stack_variant_ids');
    if (stack.length) {
      var g2 = gateOpen(cart, S('stack_deal_ids'), S('stack_trigger_variant'),
                        parseInt(S('stack_min_qty') || '0', 10));
      if (g2 !== null) {
        stack.forEach(function (v) { known[v] = 1; if (g2) want[v] = 1; });
      }
    }

    /* Nothing paid for is left, so nothing is a gift any more. Removing the last real
       product used to leave the whole stack sitting in the drawer, because each gate
       only reasoned about its own trigger. */
    var anyPaid = (cart.items || []).some(function (it) { return !isGift(it); });
    if (!anyPaid) want = {};

    var toAdd = [], toZero = {};
    Object.keys(known).forEach(function (v) {
      var line = giftLine(cart, v);
      if (want[v] && !line) toAdd.push({ id: Number(v), quantity: 1 });
      if (!want[v] && line) toZero[v] = 0;
    });

    /* Gifts the offer app added are not in `known`, and when the shopper drops below the
       deal the app stops discounting them but leaves the lines behind. They then bill at
       full price: on Overdrive that turned a $59.99 cart into $107.46. A line the app
       tagged as a gift is free by definition, so one that is being charged is an orphan
       of a deal that no longer exists. */
    (cart.items || []).forEach(function (it) {
      var kb = kbOf(it);
      if (kb && kb.gift && it.final_line_price > 0) toZero[String(it.variant_id)] = 0;
    });
    if (!toAdd.length && !Object.keys(toZero).length) { done(cart); return; }

    reconciling = true;
    var steps = [];
    if (toAdd.length) steps.push(function () {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: toAdd }) });
    });
    /* update.js keyed by variant id zeroes several lines in one request. */
    if (Object.keys(toZero).length) steps.push(function () {
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: toZero }) });
    });

    steps.reduce(function (chain, step) { return chain.then(step); }, Promise.resolve())
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (c2) { reconciling = false; done(c2); })
      .catch(function () { reconciling = false; done(cart); });
  }

  function refresh(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { reconcileGift(c, function (c2) { renderCart(c2); if (cb) cb(c2); }); })
      .catch(function () {});
  }

  function change(key, qty) {
    /* change.js answers with the new cart, and rendering that answer directly is what
       left gifts sitting in the drawer after the product that unlocked them was removed:
       this path never consulted the gates. Every quantity edit and every Remove now runs
       reconcileGift first, so dropping the trigger below its threshold clears the gifts
       in the same round trip. Gift rows carry no quantity or Remove control of their own,
       so reconcile can never fight a deliberate removal. */
    drawerEl.classList.add('loading');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) {
        return new Promise(function (res) {
          reconcileGift(c, function (c2) {
            renderCart(c2);
            d.dispatchEvent(new CustomEvent('phcd:changed'));
            res();
          });
        });
      })
      .catch(function () {})
      .then(function () { drawerEl.classList.remove('loading'); });
  }

  function add(variantId) {
    drawerEl.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function () { refresh(); d.dispatchEvent(new CustomEvent('phcd:changed')); })
      .catch(function () {})
      .then(function () { drawerEl.classList.remove('loading'); });
  }

  function onClick(e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-close')) { close(); return; }
    if (t.hasAttribute('data-inc')) { bump(t.getAttribute('data-inc'), 1); return; }
    if (t.hasAttribute('data-dec')) { bump(t.getAttribute('data-dec'), -1); return; }
    if (t.hasAttribute('data-del')) { change(t.getAttribute('data-del'), 0); return; }
    if (t.hasAttribute('data-add')) { add(t.getAttribute('data-add')); return; }
  }

  function bump(key, delta) {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var it = c.items.filter(function (x) { return x.key === key; })[0];
        if (it) change(key, Math.max(0, it.quantity + delta));
      });
  }

  /* ---------- open / close ---------- */
  function open() {
    build();
    lastFocus = d.activeElement;
    refresh();
    bgEl.classList.add('open');
    drawerEl.classList.add('open');
    d.body.classList.add('phcd-open');
    setTimeout(function () { drawerEl.focus(); }, 160);
  }
  function close() {
    if (!drawerEl) return;
    bgEl.classList.remove('open');
    drawerEl.classList.remove('open');
    d.body.classList.remove('phcd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.PHCartDrawer = { open: open, close: close, refresh: refresh };

  /* ---------- triggers ----------
     The cart icon on this store is a plain <a href="/cart">, which is exactly why
     the cart used to arrive as a page with the footer under it. Intercept those. */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/^\/cart\/?(\?|$)/.test(href) && a.id !== 'cart-icon-bubble') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    /* capture phase runs before the anchor's own listeners, so stopping here also
       stops a theme handler that would navigate programmatically - preventDefault
       alone does not cancel a window.location assignment. */
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }, true);

  d.addEventListener('cart-drawer:refresh', function () { if (drawerEl) refresh(); });
  d.addEventListener('cart:refresh', function () { if (drawerEl) refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && drawerEl) refresh(); });

  /* Two elements can carry id="cart-icon-bubble" while ph-head is in preview mode:
     the hidden theme header's link and our pill. Duplicate ids are invalid and the
     theme's cart-count section-render updates whichever it finds first, which is the
     hidden one. Rename the hidden duplicate so ours is the only match. */
  function dedupeCartId() {
    var all = d.querySelectorAll('[id="cart-icon-bubble"]');
    if (all.length < 2) return;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('.ph-head')) all[i].id = 'cart-icon-bubble-theme';
    }
  }

  function boot() { dedupeCartId(); build(); refresh(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
